$(function () {
  if (typeof initAliyunCaptcha === 'undefined') return;
  $('body').append('<input id="AliyunCaptchaButton" type="hidden">');

  var verifyCallback, temp;
  window.initGeetest = function (callback) {
    verifyCallback = callback;
    $("#AliyunCaptchaButton").click();
  };

  var captchaInstance;
  initAliyunCaptcha({
    SceneId: "1cywh88d",
    prefix: "sz19pw",
    mode: "popup",
    element: "#AliyunCaptchaCaptcha",
    button: "#AliyunCaptchaButton",
    captchaVerifyCallback: captchaVerifyCallback,
    onBizResultCallback: onBizResultCallback,
    getInstance: getInstance,
    language: "cn",
  });
  function getInstance(instance) {
    captchaInstance = instance;
  }
  function verify(captchaVerifyParam) {
    var result = { captchaVerifyResult: false };
    $.ajax({
      url: "https://member.pop136.com/captcha/aliCaptchaCheck",
      data: {
        captchaVerifyParam: captchaVerifyParam,
      },
      type: "post",
      dataType: "json",
      async: false,
      success: function (data) {
        temp = result = data.data;
      },
      error: function () {
        temp = result;
      },
    });
    return result;
  }
  function captchaVerifyCallback(captchaVerifyParam) {
    var result = verify(captchaVerifyParam);
    return {
      captchaResult: result.captchaVerifyResult,
    };
  }
  function onBizResultCallback(bizResult) {
    verifyCallback && verifyCallback(bizResult, temp);
  }
});
